import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './style/common.scss' // global css
import './fonts/iconfont.css' // icon

//引用element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(router);
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
